import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=c0cc0eee&scoped=true"
import script from "./news1.vue?vue&type=script&lang=js"
export * from "./news1.vue?vue&type=script&lang=js"
import style0 from "./news1.vue?vue&type=style&index=0&id=c0cc0eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc0eee",
  null
  
)

export default component.exports